var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { width: "720", title: "选择品牌" },
          on: { "on-ok": _vm.cursorSelect },
          model: {
            value: _vm.showSelectAuction,
            callback: function ($$v) {
              _vm.showSelectAuction = $$v
            },
            expression: "showSelectAuction",
          },
        },
        [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c("Input", {
                staticClass: "w200",
                attrs: { placeholder: "名称搜索" },
                on: { "on-enter": _vm.searchBrandAction },
                model: {
                  value: _vm.brandName,
                  callback: function ($$v) {
                    _vm.brandName = $$v
                  },
                  expression: "brandName",
                },
              }),
              _vm._v(" "),
              _c(
                "Button",
                {
                  staticClass: "ml20",
                  attrs: { type: "primary" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.searchBrandAction($event)
                    },
                  },
                },
                [_vm._v("筛选")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "h400 mt20",
              staticStyle: { "border-top": "1px solid #eee" },
            },
            [
              _c(
                "table",
                { staticClass: "spec-table" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("td", { attrs: { width: "70%", align: "center" } }, [
                        _vm._v("品牌信息"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "15%", align: "center" } }, [
                        _vm._v("是否推荐"),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "15%", align: "center" } }, [
                        _vm._v("操作"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.resultData, function (m, i) {
                    return _c("tbody", { key: i }, [
                      _c("tr", { staticClass: "border-t" }, [
                        _c("td", { staticClass: "bgWhite" }, [
                          _c(
                            "div",
                            { staticClass: "display-flex item-align-center" },
                            [
                              m.goods_picture
                                ? _c("img", {
                                    staticStyle: {
                                      width: "90px",
                                      height: "90px",
                                      display: "block",
                                      "flex-shrink": "0",
                                    },
                                    attrs: { src: m.brand_image },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "ml10" }, [
                                _c("p", [
                                  _vm._v("品牌标识：" + _vm._s(m.brand_id)),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "mt5" }, [
                                  _vm._v(_vm._s(m.brand_name)),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(m.brand_recommend ? "推荐" : "不推荐")
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "bgWhite",
                            attrs: { align: "center" },
                          },
                          [
                            _vm.selectedAuctionIdList.indexOf(m.brand_id) == -1
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "#28ab29" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.auctionSelectedAction(
                                            $event,
                                            i
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("选择")]
                                  ),
                                ])
                              : _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "#28ab29" },
                                      on: {
                                        click: function ($event) {
                                          _vm.auctionCancelAction(
                                            $event,
                                            _vm.selectedAuctionIdList.indexOf(
                                              m.brand_id
                                            )
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("取消选择")]
                                  ),
                                ]),
                          ]
                        ),
                      ]),
                    ])
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt20" },
            [
              _c("Page", {
                staticStyle: { "text-align": "right" },
                attrs: {
                  total: _vm.total,
                  "page-size": _vm.queryParams.size,
                  "show-sizer": "",
                  "show-total": "",
                  "show-elevator": "",
                  current: _vm.queryParams.page,
                },
                on: {
                  "on-page-size-change": _vm.changePageSize,
                  "on-change": _vm.changePage,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }